import { useCallback, useState } from 'react';

import { Artifact, PhaseMetrics } from '../../api/types';
import { SpassuCodeApi } from '../../api/SpassuCodeApi';

export interface UsePhaseDataLoadersResult {
  metrics: PhaseMetrics[];
  artifacts: Artifact[];
  loadMetrics: () => Promise<void>;
  loadArtifacts: () => Promise<void>;
}

export function usePhaseDataLoaders(
  activityId: string | undefined,
  api: SpassuCodeApi,
): UsePhaseDataLoadersResult {
  const [metrics, setMetrics] = useState<PhaseMetrics[]>([]);
  const [artifacts, setArtifacts] = useState<Artifact[]>([]);

  const warn = useCallback((context: string, error: unknown) => {
    const message = error instanceof Error ? error.message : String(error);
    // eslint-disable-next-line no-console
    console.warn(`[ActivityDetailPage] ${context}: ${message}`);
  }, []);

  const loadMetrics = useCallback(async () => {
    if (!activityId) return;
    try {
      const result = await api.getMetrics(activityId);
      setMetrics(result);
    } catch (error: unknown) {
      // Keep UI usable, but do not hide operational failures completely.
      warn('Falha ao carregar métricas', error);
    }
  }, [activityId, api, warn]);

  const loadArtifacts = useCallback(async () => {
    if (!activityId) return;
    try {
      const result = await api.getArtifacts(activityId);
      setArtifacts(result);
    } catch (error: unknown) {
      // Keep UI usable, but do not hide operational failures completely.
      warn('Falha ao carregar artefatos', error);
    }
  }, [activityId, api, warn]);

  return {
    metrics,
    artifacts,
    loadMetrics,
    loadArtifacts,
  };
}
